import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "downloadTimetableBlock" }
const _hoisted_2 = { class: "textBtnWrapper" }
const _hoisted_3 = { class: "smallText" }
const _hoisted_4 = ["href", "aria-label"]

import { computed } from 'vue';
import { PortList } from '..';
import { Icon } from '../../Atoms';
import { Port } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadTimetableBlock',
  props: {
    title: {},
    iconName: {},
    ports: {},
    text: {},
    downloadLink: {}
  },
  setup(__props: any) {

const props = __props;

const fileType = computed(() => {
  const match = props.downloadLink.match(/\.(\w+)(?:\?|$)/);
  return match ? match[1].toUpperCase() : '';
});

const ariaLabel = computed(() => {
  const typeText = fileType.value ? ` ${fileType.value} file` : '';
  return `Download timetable for ${props.title}-${typeText}. Opens in a new window.`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), { "icon-name": _ctx.iconName }, null, 8, ["icon-name"]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
    _createVNode(_unref(PortList), { ports: _ctx.ports }, null, 8, ["ports"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1),
      _createElementVNode("a", {
        class: "button secondary",
        href: _ctx.downloadLink,
        target: "_blank",
        "aria-label": ariaLabel.value,
        download: ""
      }, _toDisplayString(_ctx.$t('Download')), 9, _hoisted_4)
    ])
  ]))
}
}

})